import React from "react";

const MedicalServicesIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 16H11V13H14V11H11V8H9V11H6V13H9V16ZM2 20C1.45 20 0.979333 19.8043 0.588 19.413C0.196 19.021 0 18.55 0 18V6C0 5.45 0.196 4.97933 0.588 4.588C0.979333 4.196 1.45 4 2 4H6V2C6 1.45 6.196 0.979 6.588 0.587C6.97933 0.195667 7.45 0 8 0H12C12.55 0 13.021 0.195667 13.413 0.587C13.8043 0.979 14 1.45 14 2V4H18C18.55 4 19.021 4.196 19.413 4.588C19.8043 4.97933 20 5.45 20 6V18C20 18.55 19.8043 19.021 19.413 19.413C19.021 19.8043 18.55 20 18 20H2ZM2 18H18V6H2V18ZM8 4H12V2H8V4Z"
        fill="#5E6572"
      />
    </svg>
  );
};

export default MedicalServicesIcon;
